import script from "./dentaltalk_view.vue?vue&type=script&setup=true&lang=js"
export * from "./dentaltalk_view.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__